"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRequestHeaders = exports.setResponseHeaders = exports.setPagination = exports.getPagination = exports.identifier = exports.Headers = void 0;
/** Pagination request headers. */
// eslint-disable-next-line no-shadow
var Headers;
(function (Headers) {
    Headers["PerPage"] = "x-pagination-per-page";
    Headers["Page"] = "x-pagination-page";
    Headers["Total"] = "x-pagination-total";
    Headers["TotalPages"] = "x-pagination-total-pages";
    Headers["HasNext"] = "x-pagination-has-next";
})(Headers || (exports.Headers = Headers = {}));
/** Pagination identifier. */
exports.identifier = '__DEQUE_PAGINATION__';
/** Get pagination metadata from the given `data`. */
const getPagination = (data) => {
    const pagination = data[exports.identifier];
    return pagination || null;
};
exports.getPagination = getPagination;
/** Set `pagination` metadata on the given `data`. */
const setPagination = (data, pagination) => {
    const total_pages = Math.ceil(pagination.total / pagination.per_page);
    const has_next = pagination.page < total_pages;
    Object.defineProperty(data, exports.identifier, {
        value: Object.assign(Object.assign({}, pagination), { has_next,
            total_pages }),
        enumerable: false,
        configurable: false,
        writable: false
    });
    return data;
};
exports.setPagination = setPagination;
/** Set `pagination` headers on the given `res`. */
const setResponseHeaders = (res, pagination) => {
    const totalPages = isFinite(pagination.per_page)
        ? Math.ceil(pagination.total / pagination.per_page)
        : 1;
    const hasNext = pagination.page < totalPages ? 'true' : 'false';
    res.setHeader(Headers.PerPage, pagination.per_page);
    res.setHeader(Headers.Page, pagination.page);
    res.setHeader(Headers.HasNext, hasNext);
    res.setHeader(Headers.Total, pagination.total);
    res.setHeader(Headers.TotalPages, totalPages);
};
exports.setResponseHeaders = setResponseHeaders;
/** Parse pagination headers from the given `req`. */
const parseRequestHeaders = (req) => {
    const perPage = parseInt(req.headers[Headers.PerPage], 10);
    const page = parseInt(req.headers[Headers.Page], 10);
    if (Number.isNaN(perPage) || Number.isNaN(page)) {
        return {
            offset: 0,
            limit: Infinity,
            page: 0
        };
    }
    return {
        offset: (page - 1) * perPage,
        limit: perPage,
        page
    };
};
exports.parseRequestHeaders = parseRequestHeaders;
//# sourceMappingURL=utils.js.map